/* PPV 10/2026 „Größe merken“ (Entwurf 10a „Still vorausgewählt“): Die Größe, die jemand bei einer Probe zuletzt selbst gewählt hat,
   ist beim nächsten Produkt schon ausgewählt – ohne Hinweis. Beim ersten Besuch bleibt alles wie bisher.
   Merken: jede eigene Wahl im Größen-Wähler einzelner Proben (data-ppv-size-memory in snippets/product-variant-picker.liquid), auch über die Kaufleiste.
   Vorauswahl: Ein Tipp auf eine Produktkachel (data-ppv-groessen in snippets/card-product.liquid) öffnet die Probe gleich mit ?variant= der gemerkten
   Größe – Shopify zeigt Größe, Preis und Warenkorb-Knopf dann schon richtig an, nach dem Laden springt nichts um.
   Bundles sowie ausverkaufte oder fehlende Größen stehen nicht in data-ppv-groessen. Global in layout/theme.liquid geladen. */
(function () {
  if (window.ppvGroesseMerken) return;
  window.ppvGroesseMerken = true;

  var STORAGE_KEY = 'ppv:groesse';

  function sizeKey(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, '').replace(',', '.');
  }

  function load() {
    try {
      return localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function save(key) {
    try {
      localStorage.setItem(STORAGE_KEY, key);
    } catch (error) {}
  }

  // Merken: jede eigene Wahl im Größen-Wähler – auch über die Kaufleiste, die ihre Wahl direkt über pubsub meldet
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (payload) {
      var input = payload && payload.data && payload.data.event && payload.data.event.target;
      if (!input || input.type !== 'radio' || typeof input.closest !== 'function') return;
      if (!input.closest('[data-ppv-size-memory]')) return;
      save(sizeKey(input.value));
    });
  }

  // Vorauswahl: kurz vor dem Öffnen einer Kachel die gemerkte Größe als ?variant= anhängen. Die Ausgangsadresse bleibt in data-ppv-href,
  // damit eine später anders gemerkte Größe nicht an einer alten Adresse hängen bleibt (Zurück-Taste, Seiten-Cache).
  // Schon beim Berühren (pointerdown), damit auch „In neuem Tab öffnen“ und die mittlere Maustaste die aktuelle Größe bekommen;
  // click deckt die Tastatur ab.
  function withRememberedSize(event) {
    var link = event.target && event.target.closest && event.target.closest('a[data-ppv-groessen]');
    if (!link) return;

    var base = link.getAttribute('data-ppv-href') || link.getAttribute('href');
    var url;
    try {
      url = new URL(base, window.location.href);
    } catch (error) {
      return;
    }
    link.setAttribute('data-ppv-href', base);

    if (!url.searchParams.has('variant')) {
      var sizes = {};
      try {
        sizes = JSON.parse(link.getAttribute('data-ppv-groessen')) || {};
      } catch (error) {}
      var id = sizes[load()];
      if (id) url.searchParams.set('variant', id);
    }
    link.href = url.href;
  }

  document.addEventListener('pointerdown', withRememberedSize, true);
  document.addEventListener('click', withRememberedSize, true);
})();
